import { Observable, throwError } from 'rxjs';
import isEmpty from 'lodash.isempty';

import { ShoppingCartError } from '../classes/shopping-cart-error.class';
import { GeneralHttpError, BadRequestHttpError, InvalidParams } from '~shared/modules/error-handler';

export function handleError (errorResponse): Observable<ShoppingCartError> {
  let message: string;
  let errors: InvalidParams;

  if (errorResponse instanceof GeneralHttpError || errorResponse instanceof BadRequestHttpError) {
    const { title, detail } = errorResponse;
    message = title || detail;
    errors = { common: { reason: message }};

    if (errorResponse instanceof BadRequestHttpError) {
      const { invalidParams } = errorResponse;

      if (!isEmpty(invalidParams)) {
        errors = invalidParams;
      }
    }
  } else {
    message = errorResponse.message ? errorResponse.message : errorResponse.toString();
    errors = { common: { reason: message } };
  }
  return throwError(new ShoppingCartError(message, errors));
}
